<template>
  <div class="confirm">
    <Flow v-bind:step="5"/>
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h1 class="complete_text ab">手続きが完了しました。</h1>
      <router-link :to="{ name: 'subSelectBC' }" v-on:click.native="strageClear()" class="complete_btn btn btn_blue">BC選択に戻る</router-link>
    </div>
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title">BC選択</h2>
      <div class="bc_wrap">
        <div class="number_wrap pl15 pr15">
          <h3 class="bc_number bdb rb">BC：{{ this.nowBC }}</h3>
        </div>

        <div class="select_item" v-for="(value, n) in cartItems" :key="n">
          <div class="image_wrap">
            <div class="select_image">
              <img :src="imagePath + value.product.imagePath" :alt="value.product.productName" v-on:error="imageError" :data-noimage="imagePath + value.product.noImagePath">
            </div>
            <p class="select_item--title ab c5a" v-html="value.categoryName"></p>
          </div>
          <div class="select_contents">
            <div class="subscription_wrap bdb">
              <h2 class="sub_title ab c5a">定期購入</h2>
              <div class="sub_count">
                <p class="count ab c5a">数量</p>
                <p class="number rb c5a">{{ value.orderCount }}</p>
              </div>
            </div>
            <div class="kodomo_text ab">こども基金：<span class="">{{ (value.childFund) ? '支援する' : '支援しない' }}</span></div>
            <p v-if="value.goodDeal" class="good_deal_description ab">{{ value.goodDealDescription }}</p>
            <div class="select_price">
              <p class="item_price rm c5a"><span class="yen ab">￥</span>{{ value.childFund ? ((value.product.price * value.orderCount) + (100 * value.orderCount)).toLocaleString() : (value.product.price * value.orderCount).toLocaleString() }}</p>
              <p class="item_point rm c5a"><span class="point_text ab">ポイント：</span>{{ (value.product.point * value.orderCount).toLocaleString() }}<span class="point ab">pt</span></p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配送時間指定</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <p class="confirm_data rb">{{ this.userData.shippingTime }}</p>

      </div>
    </div>
    <div class="confirm_address bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">配送住所</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ this.userData.shippingName }}</p>
          <p class="data_contents">〒{{ this.userData.shippingZip + this.userData.shippingAddress }}</p>
          <!-- <p class="sameWithBc rr c5a" v-if="this.userData.addressSameWithBc001">※BC001の配送住所情報を使用します。</p> -->
        </div>

      </div>
    </div>
    <div v-show="checkSelectRepeatOrder" class="confirm_credit bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb">お支払い情報</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <div class="">
          <p class="confirm_data rb">{{ this.userData.paymethod }}</p>
          <p class="data_contents" v-if="this.userData.paymetId == 4">
            {{ this.userData.cardNumber }}
            <CreditcardExpired :expired="userData.expired" :expireYearMonth="userData.expireYearMonth" />

          </p>
          <!-- <p class="sameWithBc rr c5a" v-if="this.userData.sameWithBc001">※BC001のクレジットカード情報を使用します。</p> -->
        </div>

      </div>
    </div>

    <div class="confirm_deliveryFlag bg_white mt12 pt16 pb16 boxs1">
      <h2 class="content_title rb delyvery_flag">クレジットカード決済不可時は、<br>製品を「代金引換便」でお届けする</h2>
      <div class="confirm_wrap pl16 pr25 bdb">
        <p class="confirm_data rb">設定{{ subscriptionDenyCreditDeliveryFlag ? 'する' : 'しない' }}</p>
      </div>
    </div>

    <div class="sum_total bg_white mt12 pt16 pb16">
      <h2 class="content_title sum">合計</h2>
      <div class="sum_wrap">
        <div class="sum_contents">
          <h4 class="sum_title rb">購入代金合計</h4>
          <p class="sum_price rm"><span class="yen ab">￥</span>{{this.totalPrice.toLocaleString()}}</p>
        </div>
        <!-- <div class="sum_contents">
          <h4 class="sum_title rb">配送料</h4>
          <p class="sum_price rm"><span class="yen ab">￥</span>{{ this.shippngCost.toLocaleString() }}</p>
        </div> -->
        <!-- <div class="sum_contents">
          <h4 class="sum_title rb">代引き手数料</h4>
          <p class="sum_price rm"><span class="yen ab">￥</span>{{ this.otherCost.toLocaleString() }}</p>
        </div> -->
      </div>
      <div class="total_wrap pl16 pr17">
        <h3 class="total_price rm"><span class="yen ab">￥</span>{{ this.finalPrice.toLocaleString() }}</h3>
        <p class="total_point ab">ポイント：<span class="point_score rm">{{ this.totalPoint.toLocaleString() }}</span><span class="point">pt</span></p>
      </div>
    </div>

  </div>
</template>

<script>
import Flow from '@/components/subscription/Flow'
import RepeatOrder from '@/components/api/repeatOrder'
import Config from '@/config/config'
import { mapGetters } from 'vuex';
import CreditcardExpired from '@/components/common/CreditcardExpired.vue';

export default {
  components: {
    Flow,
    CreditcardExpired
  },
  data() {
    return {
      imagePath: Config.APIURL,
      nowBC: localStorage.getItem('subNowBC'),
      cartItems: [],
      userData: {
        shippingTime: '',
        shippingZip: '',
        shippingName: '',
        shippingAddress: '',
        addressSameWithBc001: false,
        paymethod: '',
        cardNumber: '',
        sameWithBc001: false,
      },
      totalPrice: 0,
      totalPoint: 0,
      shippngCost: 0,
      otherCost: 0,
      finalPrice: 0
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    itemList() {
      let items = JSON.parse(localStorage.getItem('repeatItemList'));
      // console.log(items);
      if(items) {
        for (var i = 0; i < items.length; i++) {
          for (var a = 0; a < items[i].itemList.length; a++) {
            items[i].itemList[a].repeatOrder ? this.cartItems.push(items[i].itemList[a]) : '';
          }
        }
      }
      if(this.cartItems.length != 0) {
        for (var i = 0; i < this.cartItems.length; i++) {
          let price = this.cartItems[i].product.price * this.cartItems[i].orderCount;
          let point = this.cartItems[i].product.point * this.cartItems[i].orderCount;

          this.totalPrice = this.totalPrice + price;
          this.totalPoint = this.totalPoint + point;
          if (this.cartItems[i].childFund) {
            this.totalPrice = this.totalPrice + (100 * this.cartItems[i].orderCount);
          }
        }
      }
    },
    calcFinalPrice () {
      this.finalPrice = 0;
      this.finalPrice = this.totalPrice + this.shippngCost + this.otherCost;
    },
    setUserDetail(shippingTime, zip, addressName, address, addressSameWithBc001, paymentId, paymentName, cardNo, sameWithBc001, expireYearMonth, expired) {
      this.userData.shippingTime = shippingTime;
      this.userData.shippingZip = zip;
      this.userData.shippingName = addressName;
      this.userData.shippingAddress = address;
      this.userData.addressSameWithBc001 = addressSameWithBc001;
      this.userData.paymetId = paymentId;
      this.userData.paymethod = paymentName;
      this.userData.cardNumber = cardNo;
      this.userData.sameWithBc001 = sameWithBc001;
      this.userData.expireYearMonth = expireYearMonth;
      this.userData.expired = expired;
    },
    createUserDetail () {
      let userDetail = JSON.parse(localStorage.getItem('userDetail'));
      if(userDetail) {
        this.setUserDetail(
          userDetail.deliveryTimeData.deliveryTimeName,
          userDetail.deliveryAddressData.zipCode,
          userDetail.deliveryAddressData.recipientName,
          userDetail.deliveryAddressData.address,
          userDetail.deliveryAddressData.sameWithBc001,
          userDetail.paymentData.paymentMethodId,
          userDetail.paymentData.paymentMethodName,
          userDetail.selectCreditData.cardNo,
          userDetail.selectCreditData.sameWithBc001,
          userDetail.selectCreditData.expireYearMonth,
          userDetail.selectCreditData.expired,
        );
      }
    },
    strageClear() {
      localStorage.removeItem('userDetail');
      localStorage.removeItem('simulateResponse');
      localStorage.removeItem('subNowBC');
      localStorage.removeItem('repeatItemList');
      localStorage.removeItem('existRepeatItem');
      localStorage.removeItem('addressSelectNumber');
      this.$store.commit('setSubscriptionDenyCreditDeliveryFlag', null);
    },
  },
  computed: mapGetters(['checkSelectRepeatOrder', 'subscriptionDenyCreditDeliveryFlag']),
  created () {
    let userDetail = JSON.parse(localStorage.getItem('userDetail'));
    console.log(userDetail);
    this.itemList();
    this.calcFinalPrice();
    this.createUserDetail();
    // this.completeOrder();
  },
};
</script>

<style lang="css" scoped>
.sameWithBc {
  color: red;
  font-size: 13px;
}
.complete_text {
  font-size: 20px;
  text-align: center;
}
.complete_btn {
  margin-top: 30px;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 15px 30px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 33%;
}
.month_item {
  display: flex;
  margin-top: 16px;
}
.select_item--title {
  font-size: 12px;
  margin-top: 5px;
}

.subscription_wrap {
  display: flex;
  justify-content: space-between;
}
.subscription_wrap .sub_title {
  font-size: 16px;
}
.subscription_wrap .sub_count {
  align-items: center;
  display: flex;
}

.subscription_wrap .count {
  font-size: 12px;
}

.subscription_wrap .number {
  font-size: 20px;
  margin-left: 27px;
}
.kodomo_text {
  display: flex;
  font-size: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}
.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 11px;
}

.content_title {
  margin-top: 12px;
  width: 221px;
}

.selsct_bc {
  font-size: 20px;
  margin-top: 9px;
  padding-left: 8px;
  position: relative;
}
.selsct_bc::before {
  background-color: #4FCCD4;
  bottom: 0;
  content: '';
  height: 25px;
  left: 0;
  margin: auto;
  position: absolute;
  top: 0;
  width: 4px;
}

.item_price {
  font-size: 26px;
}

.item_point {
  font-size: 16px;
}

.select_contents {
  margin-top: 60px;
  width: 59%;
}

.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}
.content_title.delyvery_flag {
  width: 260px;
}

.bc_wrap .bc_number {
  font-size: 20px;
  margin-top: 15px;
  padding-bottom: 5px;
}
.bc_wrap .item_wrap {
  -ms-align-items: flex-start;
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.bc_wrap .item_contents {
  width: 31%;
}

.bc_wrap .item_image {
  margin: auto;
  width: 90%;
}

.bc_wrap .item_title {
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
}

.bc_wrap .contents_detail {
  width: 57.4%;
}

.bc_wrap .count_wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.bc_wrap .month {
  font-size: 24px;
}

.bc_wrap .month_text {
  font-size: 16px;
  margin-left: 2px;
}

/* .bc_wrap .count {
  font-size: 26px;
} */

/* .bc_wrap .count_text {
  font-size: 14px;
  margin-right: 19px;
} */

.bc_wrap .child_wrap {
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 22px;
}

.bc_wrap .price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.bc_wrap .price {
  font-size: 26px;
}

.bc_wrap .yen {
  font-size: 20px;
}
.bc_wrap .point {
  font-size: 16px;
}
.bc_wrap .point_text {
  font-size: 12px;
}
.bc_wrap .pt {
  font-size: 14px;
}

.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}

.count {
  font-size: 20px;
  margin-left: 25px;
}

.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap,
.confirm_deliveryFlag .confirm_wrap {
  margin-top: 24px;
}


.sum_wrap {
  margin-top: 25px;
  padding: 0 15px;
}
.sum_contents {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.sum_contents:last-child {
  border-bottom: 1px solid #C9C9C9;
  padding-bottom: 13px;
}
.sum_title {
  font-size: 14px;
}
.yen {
  font-size: 12px;
}
.sum_price {
  font-size: 16px;
}

.sum_total {
  padding-bottom: 48px;
}
.total_wrap {
  color: #009FA9;
  margin-top: 16px;
  text-align: right;
}

.total_wrap .total_price {
  font-size: 26px;
}

.total_wrap .yen {
  font-size: 20px;
}

.total_wrap .total_point {
  font-size: 12px;
  margin-top: 3px;
}
.total_wrap .point_score {
  font-size: 16px;
}
.total_wrap .point {
  font-size: 12px;
}
.complete {
  margin-top: 56px;
}

.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}

.good_deal_description {
  font-size: 12px;
  margin-top: 8px;
  text-align: right;
  white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// src/views/subscription/Complete.vue